export default __webpack_public_path__ + "static/AAVE-4b84a0b56007efc134d1fa08b8b9c06b.jpg";